import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  spaBookingData: null,
};

const spaBookingSlice = createSlice({
  name: 'spaBooking',
  initialState,
  reducers: {
    resetSpaBooking: () => initialState,
    spaBookingSuccess: (state, action) => {
      state.spaBookingData = action?.payload;
    }
  },
});

export const { resetSpaBooking, spaBookingSuccess } = spaBookingSlice.actions;

export default spaBookingSlice.reducer;
